import { EEGPage } from "./EEGPage";
import { TimeSeriesPageQueue } from "./TimeSeriesDataQueue";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

export class EEGTimeSeriesPageManager extends TimeSeriesPageManager<EEGPage> {
	protected pageQueue = new TimeSeriesPageQueue<EEGPage>(this.getQueueConcurrency())

	private getQueueConcurrency(): number {
		try {
			const nQueue = window.localStorage.getItem("MCP_EEG_QUEUE_CONCURRENCY")
			return nQueue ? Number.parseInt(nQueue) : 8
		} catch (e) {
			return 8
		}
	}

	getPageMaker(): () => EEGPage {
		return (): EEGPage => new EEGPage(this)
	}

	protected getNumberOfCachedPages(): number {
		return 256
	}
}
